import { getChargedAgainstOptions, getTransactionSummary } from './services';
import { IChargedAgainstOption, ITransactionSummary } from './types';

const TTL_MS = 60 * 1000;

let summaryCache: { data: ITransactionSummary; fetchedAt: number } | null = null;
let chargedAgainstCache: { data: IChargedAgainstOption[]; fetchedAt: number } | null = null;
let summaryInflight: Promise<ITransactionSummary> | null = null;
let chargedAgainstInflight: Promise<IChargedAgainstOption[]> | null = null;

export function clearTransactionPanelCache(): void {
	summaryCache = null;
	chargedAgainstCache = null;
	summaryInflight = null;
	chargedAgainstInflight = null;
}

export async function fetchTransactionSummaryCached(): Promise<ITransactionSummary> {
	if (summaryCache && Date.now() - summaryCache.fetchedAt < TTL_MS) {
		return summaryCache.data;
	}

	if (!summaryInflight) {
		summaryInflight = getTransactionSummary()
			.then((response) => {
				summaryCache = { data: response.data, fetchedAt: Date.now() };
				summaryInflight = null;
				return response.data;
			})
			.catch((error) => {
				summaryInflight = null;
				throw error;
			});
	}

	return summaryInflight;
}

export async function fetchChargedAgainstOptionsCached(): Promise<IChargedAgainstOption[]> {
	if (chargedAgainstCache && Date.now() - chargedAgainstCache.fetchedAt < TTL_MS) {
		return chargedAgainstCache.data;
	}

	if (!chargedAgainstInflight) {
		chargedAgainstInflight = getChargedAgainstOptions()
			.then((response) => {
				chargedAgainstCache = { data: response.data, fetchedAt: Date.now() };
				chargedAgainstInflight = null;
				return response.data;
			})
			.catch((error) => {
				chargedAgainstInflight = null;
				throw error;
			});
	}

	return chargedAgainstInflight;
}
